module.exports = __webpack_public_path__ + "img/0a1927f.jpg";